import { flatten } from 'ramda';
import React, { memo } from 'react';

import styles from './AlbumsLayout.css';

export interface AlbumsLayoutProps {
    children: any;
    qaTitle?: string;
}

export const AlbumsLayout = memo(function AlbumsLayout({ children, qaTitle }: AlbumsLayoutProps) {
    const albums = flatten(children);

    return (
        <div className={styles.root} data-qa-id="albums-layout" data-qa-title={qaTitle}>
            {albums}
        </div>
    );
});
